"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagClassNames: function() {
        return tagClassNames;
    },
    useIconStyles: function() {
        return useIconStyles;
    },
    useMediaStyles: function() {
        return useMediaStyles;
    },
    usePrimaryTextStyles: function() {
        return usePrimaryTextStyles;
    },
    useSecondaryTextBaseClassName: function() {
        return useSecondaryTextBaseClassName;
    },
    useTagStyles_unstable: function() {
        return useTagStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reacttheme = require("@fluentui/react-theme");
const tagClassNames = {
    root: 'fui-Tag',
    media: 'fui-Tag__media',
    icon: 'fui-Tag__icon',
    primaryText: 'fui-Tag__primaryText',
    secondaryText: 'fui-Tag__secondaryText',
    dismissIcon: 'fui-Tag__dismissIcon'
};
/**
 * Inner horizontal space left and right of Tag
 */ const tagSpacingMedium = '7px';
const tagSpacingSmall = '5px';
const tagSpacingExtraSmall = '5px';
const mediumIconSize = '20px';
const smallIconSize = '16px';
const extraSmallIconSize = '12px';
const baseStyles = {
    // reset default button style:
    fontFamily: 'inherit',
    padding: '0px',
    appearance: 'button',
    textAlign: 'unset',
    display: 'inline-grid',
    alignItems: 'center',
    gridTemplateAreas: `
  "media primary   dismissIcon"
  "media secondary dismissIcon"
  `,
    boxSizing: 'border-box',
    width: 'fit-content',
    border: `${_reacttheme.tokens.strokeWidthThin} solid ${_reacttheme.tokens.colorTransparentStroke}`
};
const useRootRoundedBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r1d3fbai", "r89ofxt", {
    r: [
        ".r1d3fbai{font-family:inherit;padding:0px;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;display:inline-grid;align-items:center;grid-template-areas:\"media primary   dismissIcon\" \"media secondary dismissIcon\";box-sizing:border-box;width:fit-content;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-radius:var(--borderRadiusMedium);}",
        ".r1d3fbai[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}",
        ".r89ofxt{font-family:inherit;padding:0px;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;display:inline-grid;align-items:center;grid-template-areas:\"media primary   dismissIcon\" \"media secondary dismissIcon\";box-sizing:border-box;width:fit-content;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-radius:var(--borderRadiusMedium);}",
        ".r89ofxt[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}"
    ],
    s: [
        "@media (forced-colors: active){.r1d3fbai{position:relative;}.r1d3fbai::before{content:\"\";border-top-width:var(--strokeWidthThin);border-top-style:solid;position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);}}",
        "@media (forced-colors: active){.r89ofxt{position:relative;}.r89ofxt::before{content:\"\";border-top-width:var(--strokeWidthThin);border-top-style:solid;position:absolute;top:-1px;right:-1px;left:-1px;bottom:-1px;border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);}}"
    ]
});
const useRootCircularBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r76els4", "r1g7lw0i", {
    r: [
        ".r76els4{font-family:inherit;padding:0px;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;display:inline-grid;align-items:center;grid-template-areas:\"media primary   dismissIcon\" \"media secondary dismissIcon\";box-sizing:border-box;width:fit-content;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-radius:var(--borderRadiusCircular);}",
        ".r76els4[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusCircular);border-bottom-left-radius:var(--borderRadiusCircular);border-top-right-radius:var(--borderRadiusCircular);border-top-left-radius:var(--borderRadiusCircular);outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}",
        ".r1g7lw0i{font-family:inherit;padding:0px;-webkit-appearance:button;-moz-appearance:button;-ms-appearance:button;appearance:button;text-align:unset;display:inline-grid;align-items:center;grid-template-areas:\"media primary   dismissIcon\" \"media secondary dismissIcon\";box-sizing:border-box;width:fit-content;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);border-radius:var(--borderRadiusCircular);}",
        ".r1g7lw0i[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusCircular);border-bottom-right-radius:var(--borderRadiusCircular);border-top-left-radius:var(--borderRadiusCircular);border-top-right-radius:var(--borderRadiusCircular);outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}"
    ],
    s: [
        "@media (forced-colors: active){.r76els4{position:relative;}.r76els4::before{content:\"\";border-top-width:var(--strokeWidthThin);border-top-style:solid;border-left-width:var(--strokeWidthThin);border-left-style:solid;border-right-width:var(--strokeWidthThin);border-right-style:solid;position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;border-radius:var(--borderRadiusCircular);}}",
        "@media (forced-colors: active){.r1g7lw0i{position:relative;}.r1g7lw0i::before{content:\"\";border-top-width:var(--strokeWidthThin);border-top-style:solid;border-right-width:var(--strokeWidthThin);border-right-style:solid;border-left-width:var(--strokeWidthThin);border-left-style:solid;position:absolute;top:-1px;right:-1px;left:-1px;bottom:-1px;border-radius:var(--borderRadiusCircular);}}"
    ]
});
const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    filled: {
        De3pzq: "f16xq7d1",
        sj55zd: "fkfq4zb"
    },
    outline: {
        De3pzq: "fhovq9v",
        sj55zd: "fkfq4zb",
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ]
    },
    brand: {
        De3pzq: "f16xkysk",
        sj55zd: "faj9fo0"
    },
    medium: {
        Bqenvij: "f1d2rq10"
    },
    small: {
        Bqenvij: "frvgh55"
    },
    "extra-small": {
        Bqenvij: "fjamq6b"
    }
}, {
    d: [
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".faj9fo0{color:var(--colorBrandForeground2);}",
        ".f1d2rq10{height:32px;}",
        ".frvgh55{height:24px;}",
        ".fjamq6b{height:20px;}"
    ]
});
const useRootDisabledStyles = /*#__PURE__*/ (0, _react.__styles)({
    filled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o",
        g2u3we: "fgig46g",
        h3c5rm: [
            "f1mxt3zg",
            "fziff3p"
        ],
        B9xav0g: "f250w3l",
        zhjwy3: [
            "fziff3p",
            "f1mxt3zg"
        ]
    },
    outline: {
        Bceei9c: "fdrzuqr",
        De3pzq: "fhovq9v",
        sj55zd: "f1s2aq7o",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ]
    },
    brand: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o",
        g2u3we: "fgig46g",
        h3c5rm: [
            "f1mxt3zg",
            "fziff3p"
        ],
        B9xav0g: "f250w3l",
        zhjwy3: [
            "fziff3p",
            "f1mxt3zg"
        ]
    }
}, {
    d: [
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fgig46g{border-top-color:var(--colorTransparentStrokeDisabled);}",
        ".f1mxt3zg{border-right-color:var(--colorTransparentStrokeDisabled);}",
        ".fziff3p{border-left-color:var(--colorTransparentStrokeDisabled);}",
        ".f250w3l{border-bottom-color:var(--colorTransparentStrokeDisabled);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}"
    ]
});
/**
 * Styles for root slot when Tag is without leading media/icon
 */ const useRootWithoutMediaStyles = /*#__PURE__*/ (0, _react.__styles)({
    medium: {
        uwmqm3: [
            "f1rtp3s9",
            "f18k1jr3"
        ]
    },
    small: {
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ]
    },
    "extra-small": {
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ]
    }
}, {
    d: [
        ".f1rtp3s9{padding-left:7px;}",
        ".f18k1jr3{padding-right:7px;}",
        ".f15vdbe4{padding-left:5px;}",
        ".fwiuce9{padding-right:5px;}"
    ]
});
/**
 * Styles for root slot when Tag is without dismiss icon
 */ const useRootWithoutDismissStyles = /*#__PURE__*/ (0, _react.__styles)({
    medium: {
        z189sj: [
            "f18k1jr3",
            "f1rtp3s9"
        ]
    },
    small: {
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ]
    },
    "extra-small": {
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ]
    }
}, {
    d: [
        ".f18k1jr3{padding-right:7px;}",
        ".f1rtp3s9{padding-left:7px;}",
        ".fwiuce9{padding-right:5px;}",
        ".f15vdbe4{padding-left:5px;}"
    ]
});
const useIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Ijaq50: "f11uok23",
        Br312pm: "f1qdfnnj",
        nk6f5a: "f1s27gz",
        Bw0ie65: "f86d0yl",
        mc9l5x: "f22iagw"
    },
    medium: {
        uwmqm3: [
            "f1rtp3s9",
            "f18k1jr3"
        ],
        z189sj: [
            "f7x41pl",
            "fruq291"
        ],
        a9b677: "f64fuq3",
        Be2twd7: "fe5j1ua"
    },
    small: {
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ],
        z189sj: [
            "ffczdla",
            "fgiv446"
        ],
        a9b677: "fjw5fx7",
        Be2twd7: "f4ybsrx"
    },
    "extra-small": {
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ],
        z189sj: [
            "ffczdla",
            "fgiv446"
        ],
        a9b677: "frx94fk",
        Be2twd7: "f1ugzwwg"
    }
}, {
    d: [
        ".f11uok23{grid-row-start:media;}",
        ".f1qdfnnj{grid-column-start:media;}",
        ".f1s27gz{grid-row-end:media;}",
        ".f86d0yl{grid-column-end:media;}",
        ".f22iagw{display:flex;}",
        ".f1rtp3s9{padding-left:7px;}",
        ".f18k1jr3{padding-right:7px;}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f64fuq3{width:20px;}",
        ".fe5j1ua{font-size:20px;}",
        ".f15vdbe4{padding-left:5px;}",
        ".fwiuce9{padding-right:5px;}",
        ".ffczdla{padding-right:var(--spacingHorizontalXXS);}",
        ".fgiv446{padding-left:var(--spacingHorizontalXXS);}",
        ".fjw5fx7{width:16px;}",
        ".f4ybsrx{font-size:16px;}",
        ".frx94fk{width:12px;}",
        ".f1ugzwwg{font-size:12px;}"
    ]
});
const useMediaStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Ijaq50: "f11uok23",
        Br312pm: "f1qdfnnj",
        nk6f5a: "f1s27gz",
        Bw0ie65: "f86d0yl",
        mc9l5x: "f22iagw",
        uwmqm3: [
            "f10xn8zz",
            "f136y8j8"
        ]
    },
    medium: {
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ]
    },
    small: {
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ]
    },
    "extra-small": {
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ]
    }
}, {
    d: [
        ".f11uok23{grid-row-start:media;}",
        ".f1qdfnnj{grid-column-start:media;}",
        ".f1s27gz{grid-row-end:media;}",
        ".f86d0yl{grid-column-end:media;}",
        ".f22iagw{display:flex;}",
        ".f10xn8zz{padding-left:1px;}",
        ".f136y8j8{padding-right:1px;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}"
    ]
});
const useDismissIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Ijaq50: "fneo8i2",
        Br312pm: "frbqjvc",
        nk6f5a: "f1a6k60w",
        Bw0ie65: "f1ay3jj",
        mc9l5x: "f22iagw",
        ze5xyy: "f4xjyn1",
        oy3o9n: "f1xtr1b3"
    },
    medium: {
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ],
        z189sj: [
            "f18k1jr3",
            "f1rtp3s9"
        ],
        Be2twd7: "fe5j1ua"
    },
    small: {
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ],
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ],
        Be2twd7: "f4ybsrx"
    },
    "extra-small": {
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ],
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ],
        Be2twd7: "f1ugzwwg"
    },
    filled: {
        eoavqd: "f8491dx",
        Bi91k9c: "f3ymbdj",
        lj723h: "fryz5bw"
    },
    outline: {
        eoavqd: "f8491dx",
        Bi91k9c: "f3ymbdj",
        lj723h: "fryz5bw"
    },
    brand: {
        eoavqd: "f8491dx",
        Bi91k9c: "f3ymbdj",
        lj723h: "fryz5bw"
    }
}, {
    d: [
        ".fneo8i2{grid-row-start:dismissIcon;}",
        ".frbqjvc{grid-column-start:dismissIcon;}",
        ".f1a6k60w{grid-row-end:dismissIcon;}",
        ".f1ay3jj{grid-column-end:dismissIcon;}",
        ".f22iagw{display:flex;}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".f18k1jr3{padding-right:7px;}",
        ".f1rtp3s9{padding-left:7px;}",
        ".fe5j1ua{font-size:20px;}",
        ".fgiv446{padding-left:var(--spacingHorizontalXXS);}",
        ".ffczdla{padding-right:var(--spacingHorizontalXXS);}",
        ".fwiuce9{padding-right:5px;}",
        ".f15vdbe4{padding-left:5px;}",
        ".f4ybsrx{font-size:16px;}",
        ".f1ugzwwg{font-size:12px;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1xtr1b3:active{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    h: [
        ".f8491dx:hover{cursor:pointer;}",
        ".f3ymbdj:hover{color:var(--colorCompoundBrandForeground1Hover);}"
    ],
    a: [
        ".fryz5bw:active{color:var(--colorCompoundBrandForeground1Pressed);}"
    ]
});
const usePrimaryTextStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Huce71: "fz5stix",
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ],
        z189sj: [
            "ffczdla",
            "fgiv446"
        ]
    },
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    small: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    "extra-small": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    withoutSecondaryText: {
        Br312pm: "faqcfhe",
        Ijaq50: "f1q3ipgb",
        nk6f5a: "fc0ab3q",
        Byoj8tv: "f1g03r3y"
    },
    withSecondaryText: {
        Ijaq50: "f1q3ipgb",
        Br312pm: "faqcfhe",
        nk6f5a: "fs32cm1",
        Bw0ie65: "f1bo7viq",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        B6of3ja: "f1ryq6si"
    }
}, {
    d: [
        ".fz5stix{white-space:nowrap;}",
        ".fgiv446{padding-left:var(--spacingHorizontalXXS);}",
        ".ffczdla{padding-right:var(--spacingHorizontalXXS);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".faqcfhe{grid-column-start:primary;}",
        ".f1q3ipgb{grid-row-start:primary;}",
        ".fc0ab3q{grid-row-end:secondary;}",
        ".f1g03r3y{padding-bottom:var(--spacingHorizontalXXS);}",
        ".fs32cm1{grid-row-end:primary;}",
        ".f1bo7viq{grid-column-end:primary;}",
        ".f1ryq6si{margin-top:-2px;}"
    ]
});
const useSecondaryTextBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r7hv1ps", "rnrslm9", [
    ".r7hv1ps{grid-area:secondary;padding-left:var(--spacingHorizontalXXS);padding-right:var(--spacingHorizontalXXS);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase100);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase100);white-space:nowrap;}",
    ".rnrslm9{grid-area:secondary;padding-right:var(--spacingHorizontalXXS);padding-left:var(--spacingHorizontalXXS);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase100);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase100);white-space:nowrap;}"
]);
const useTagStyles_unstable = (state)=>{
    const rootRoundedBaseClassName = useRootRoundedBaseClassName();
    const rootCircularBaseClassName = useRootCircularBaseClassName();
    const rootStyles = useRootStyles();
    const rootDisabledStyles = useRootDisabledStyles();
    const rootWithoutMediaStyles = useRootWithoutMediaStyles();
    const rootWithoutDismissStyles = useRootWithoutDismissStyles();
    const iconStyles = useIconStyles();
    const mediaStyles = useMediaStyles();
    const dismissIconStyles = useDismissIconStyles();
    const primaryTextStyles = usePrimaryTextStyles();
    const secondaryTextBaseClassName = useSecondaryTextBaseClassName();
    const { shape, size, appearance } = state;
    state.root.className = (0, _react.mergeClasses)(tagClassNames.root, shape === 'rounded' ? rootRoundedBaseClassName : rootCircularBaseClassName, state.disabled ? rootDisabledStyles[appearance] : rootStyles[appearance], rootStyles[size], !state.media && !state.icon && rootWithoutMediaStyles[size], !state.dismissIcon && rootWithoutDismissStyles[size], state.root.className);
    if (state.media) {
        state.media.className = (0, _react.mergeClasses)(tagClassNames.media, mediaStyles.base, mediaStyles[size], state.media.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(tagClassNames.icon, iconStyles.base, iconStyles[size], state.icon.className);
    }
    if (state.primaryText) {
        state.primaryText.className = (0, _react.mergeClasses)(tagClassNames.primaryText, primaryTextStyles.base, primaryTextStyles[size], state.secondaryText ? primaryTextStyles.withSecondaryText : primaryTextStyles.withoutSecondaryText, state.primaryText.className);
    }
    if (state.secondaryText) {
        state.secondaryText.className = (0, _react.mergeClasses)(tagClassNames.secondaryText, secondaryTextBaseClassName, state.secondaryText.className);
    }
    if (state.dismissIcon) {
        state.dismissIcon.className = (0, _react.mergeClasses)(tagClassNames.dismissIcon, dismissIconStyles.base, dismissIconStyles[size], !state.disabled && dismissIconStyles[appearance], state.dismissIcon.className);
    }
    return state;
}; //# sourceMappingURL=useTagStyles.styles.js.map
